import { getValueFromWindowObject, isLoggedIn } from '../jsV2/helpers/twHelper';
import Page from '../js/lib/page';

/**
 * Innovation Guild: search only experiment helper
 */

// show faq search result for customer searched question
export const isShowOnlySearchLayoutEnabled = () =>
  getValueFromWindowObject('isHomeExpEnabledForOnlySearchBar') === true;
// launch bot for customer searched question
export const isBotExperienceEnabled = () => getValueFromWindowObject('isBotExperience') === true;

// show transaction first view in help center homepage
export const isHomeExpTransactionLayoutEnabled = () =>
  isLoggedIn() && getValueFromWindowObject('isHomeExpEnabledForTransactionFirstView') === true;

export const isElmoTreatmentEnabled = () => isLoggedIn() && Page.elmoTreatments() && Page.elmoTreatments().length > 0;
